import { colors } from "@material-ui/core";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let theme = createTheme({
	color: {
		primary: "#d9594e",
		secondary: "#E5E3DB",
	},
	palette: {
		background: {
			dark: "#383838",
			alt: colors.common.white,
		},
		primary: {
			main: "#d9594e",
			hover: "#d9594e90",
		},
		secondary: {
			main: "#E5E3DB",
		},
		danger: {
			main: colors.red[500],
			light: colors.red[300],
		},
		success: {
			main: colors.green[500],
		},
		text: {
			primary: "#d9594e",
			secondary: "#383838",
			danger: colors.red[500],
		},
		typography: {
			fontFamily: "Varela Round",
		},
	},
	typography: {
		h1: {
			fontSize: "5rem",
			fontFamily: "Varela Round",
			textTransform: "uppercase",
			color: "#d9594e",
		},
		h2: {
			fontSize: "2.8rem",
			fontFamily: "Varela Round",
			textTransform: "uppercase",
			color: "#d9594e",
		},
		h3: {
			fontSize: "1.5rem",
			fontFamily: "Varela Round",
			fontWeight: 300,
			color: "#424242",
			textTransform: "uppercase",
		},
		h4: {
			fontSize: "1.3rem",
			fontFamily: "Varela Round",
			fontWeight: 300,
			color: "#d9594e",
			textTransform: "uppercase",
		},
		h5: {
			fontSize: "2rem",
			fontFamily: "Varela Round",
			fontWeight: 200,
			color: "#d9594e",
		},
		body1: {
			fontFamily: "Varela Round",
			fontSize: "1.1rem",
			color: "#383838",
		},
		caption: {
			fontFamily: "Varela Round",
			fontSize: "0.8rem",
			color: "#383838",
		},
	},
});

theme = responsiveFontSizes(theme);

export default theme;
